import { Typography } from '@hulu/react-style-components';
import { IconClose } from '@hulu-react-style-components/icons';
import { Modal, ModalProps } from '@material-ui/core';
import { Divider } from 'antd';
import { type FC, MouseEventHandler } from 'react';

import {
  BackIcon,
  BackIconContainer,
  CloseIconContainer,
  Container,
  HeaderWrapper,
  ModalButtonActionsWrapper,
  ModalContentContainer,
  ModalMainContentWrapper,
  StyledTitle,
  TitleContainer,
  TopDivider,
} from './styled';

type Props = {
  title: string;
  subtitle?: string;
  FooterButtons: React.ReactElement;
  dataTestId?: string;
  showDividerLineBelowTitles?: boolean;
  onBackClicked?: () => void;
} & ModalProps;

const CreativeBaseModal: FC<Props> = ({
  open,
  title,
  onClose,
  subtitle,
  children,
  FooterButtons,
  onBackClicked,
  dataTestId = 'creativeBaseModal',
  showDividerLineBelowTitles = false,
  ...rest
}): JSX.Element => (
  <Modal open={open} onClose={onClose} data-testid={dataTestId} {...rest}>
    <Container>
      <CloseIconContainer>
        <IconClose onClick={onClose as MouseEventHandler<SVGSVGElement>} data-testid="creativeBaseModalCloseIcon" />
      </CloseIconContainer>
      <TitleContainer>
        <HeaderWrapper>
          {onBackClicked && (
            <BackIconContainer>
              <BackIcon data-testid="backButton" onClick={onBackClicked} />
            </BackIconContainer>
          )}
          <StyledTitle data-testid="creativeBaseModalTitle">{title}</StyledTitle>
        </HeaderWrapper>
        {subtitle && (
          <Typography variant="body1" data-testid="creativeBaseModalSubTitle">
            {subtitle}
          </Typography>
        )}
        {showDividerLineBelowTitles && <TopDivider data-testid="topDivider" />}
      </TitleContainer>
      <ModalContentContainer>
        <ModalMainContentWrapper>{children}</ModalMainContentWrapper>
        <Divider />
        <ModalButtonActionsWrapper>{FooterButtons}</ModalButtonActionsWrapper>
      </ModalContentContainer>
    </Container>
  </Modal>
);

export default CreativeBaseModal;
